import { cn } from "@/utils/cn";
import { memo } from "react";

export const ListShadow = memo(function ListShadow() {
  return (
    <div
      className={cn(
        "h-8 bg-gradient-to-b from-white to-transparent",
        "pointer-events-none absolute top-0 right-4 left-4 z-100 transition-opacity duration-300",
      )}
    />
  );
});
